module.exports = __webpack_public_path__ + "img/lasource-35.bd0f60a7.jpg";